import { CircularProgress } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { AccessOutcome, useClientAccess } from "../../api/useClientAccess";
import { logoutWithCleanup } from "../../env";
import { useAuth } from "../../hooks/useAuth";

const Loading: React.FC = () => {
  return (
    <div className="flex h-screen justify-center items-center">
      <CircularProgress size={80} />
    </div>
  );
};

const NoAccess: React.FC = () => {
  const [t] = useTranslation();
  const { data: clientAccess, isLoading } = useClientAccess();
  const { logout } = useAuth();

  if (isLoading) {
    return <Loading />;
  }

  const isNoData = clientAccess?.accessOutcome === AccessOutcome.HasAccessNoData;
  const brandDisplayName = clientAccess?.brandDisplayName;

  const header = isNoData
    ? brandDisplayName
      ? t("noData.header.branded", { brand: brandDisplayName })
      : t("noData.header.default")
    : brandDisplayName
      ? t("noAccess.header.branded", { brand: brandDisplayName })
      : t("noAccess.header.default");

  const description = isNoData ? t("noData.description") : t("noAccess.description");

  return (
    <div className="text-white text-center">
      <h1 className="text-3xl font-bold mb-8">{header}</h1>
      <p className="mb-8">{description}</p>
      <button
        className="border border-white rounded p-2 mt-6 hover:bg-white hover:text-primary transition duration-150"
        onClick={() => logoutWithCleanup(logout)}
      >
        {t("common.logout")}
      </button>
    </div>
  );
};

export default NoAccess;
